var map = {
	"./daily_ic@3x.png": "SDaD",
	"./hot_ic@3x.png": "j0QA",
	"./left_ic@3x.png": "diJ0",
	"./right_ic@3x.png": "vQ0N",
	"./sale_ic@3x.png": "ArKv",
	"./type_ic@3x.png": "HKmV"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WfSu";